// Shared affordance for table cells that open the Deep View drawer.
// A dotted underline marks the cell as clickable at rest; hover brightens it.
//
// The underline is scoped to the element carrying DEEP_VIEW_VALUE_CLASS rather
// than the whole cell: a decoration set on the wrapper propagates into every
// descendant (percentage badges, comparison values) and CSS gives descendants
// no way to opt out of it.
export const DEEP_VIEW_VALUE_CLASS = "deep-view-value";

const valueSelector = `&.${DEEP_VIEW_VALUE_CLASS}, & .${DEEP_VIEW_VALUE_CLASS}`;
const hoverSelector = `&:hover.${DEEP_VIEW_VALUE_CLASS}, &:hover .${DEEP_VIEW_VALUE_CLASS}`;

export const deepViewCellSx = {
  cursor: "pointer",
  width: "fit-content",
  [valueSelector]: {
    textDecorationLine: "underline",
    textDecorationStyle: "dotted",
    textDecorationThickness: "1px",
    textDecorationColor: "rgba(0, 0, 0, 0.38)",
    textUnderlineOffset: "3px",
    transition: "color 120ms ease, text-decoration-color 120ms ease",
  },
  [hoverSelector]: {
    color: "#7B1FA2",
    textDecorationColor: "#7B1FA2",
  },
  "&:focus-visible": {
    outline: "2px solid #7B1FA2",
    outlineOffset: "2px",
    borderRadius: "2px",
  },
};
